import React, { ReactNode } from "react";
import { TabContextProvider } from "./context/TabContext";
import { FormProvider } from "context/BlogContext";
import { JewelleryPriceProvider } from "context/JwelleryPriceContext";

interface TabContainerProps {
  children: ReactNode;
}

const GlobalProvider: React.FC<TabContainerProps> = ({
  children,
}: TabContainerProps) => {
  return (
    <TabContextProvider>
      <FormProvider>
        <JewelleryPriceProvider>{children}</JewelleryPriceProvider>
      </FormProvider>
    </TabContextProvider>
  );
};

export { GlobalProvider };
